import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { Helper } from '../static/helper';
import ScrollToTop from '../components/ScrollToTop';

const Contact = () => {

    return (
        <>
            <ScrollToTop>
                <div>
                    <NavBar />
                </div>

                <main className="min-h-screen bg-gray-50">
                    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                        <div className="text-center mb-8">
                            <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl mb-4">
                                Nous contacter
                            </h1>
                            <div className='flex justify-center'>
                                <div className='w-24 border-b-4' style={{ borderColor: Helper.footerBackGroundColor }}></div>
                            </div>
                        </div>

                        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                            <div className="flex flex-col lg:flex-row">

                                {/* Carte Google Maps */}
                                <div className="w-full lg:w-1/2">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3109.085782925896!2d0.2252779769315552!3d49.15134118004541!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e1c4453a6bc295%3A0x2dd9c747c0427e68!2s56%20B%20Bd%20Herbet%20Fournet%2C%2014100%20Lisieux!5e1!3m2!1sfr!2sfr!4v1788040173530!5m2!1sfr!2sfr"
                                        className="w-full h-64 sm:h-80 lg:h-full lg:min-h-[500px]"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Localisation du cabinet Osmose Chiropratique sur Google Maps"
                                    ></iframe>
                                </div>

                                {/* Informations de contact */}
                                <div className="w-full lg:w-1/2 p-6 sm:p-8 lg:p-10" style={{ background: Helper.footerBackGroundColor }}>

                                    {/* Emplacement */}
                                    <section aria-labelledby="location-title" className="mb-8">
                                        <h2 id="location-title" className="text-white font-bold text-xl mb-3 flex items-center gap-2">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            Emplacement
                                        </h2>
                                        <address className="not-italic text-gray-300 text-sm sm:text-base leading-relaxed">
                                            <p>56B Boulevard Herbet Fournet</p>
                                            <p>14100 Lisieux</p>
                                        </address>
                                    </section>

                                    {/* Horaires */}
                                    <section aria-labelledby="hours-title" className="mb-8">
                                        <h2 id="hours-title" className="text-white font-bold text-xl mb-3 flex items-center gap-2">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            Horaires
                                        </h2>
                                        <div className="text-gray-300 text-sm sm:text-base space-y-1">
                                            <p><span className="text-white font-semibold">Lundi - Samedi :</span> 9h - 19h30</p>
                                            <p><span className="text-white font-semibold">Dimanche :</span> Fermé</p>
                                        </div>
                                    </section>

                                    {/* Nous contacter */}
                                    <section aria-labelledby="contact-title">
                                        <h2 id="contact-title" className="text-white font-bold text-xl mb-4 flex items-center gap-2">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                            </svg>
                                            Nous contacter
                                        </h2>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                            {/* Emilie */}
                                            <div className="bg-white/10 rounded-xl p-4">
                                                <p className="text-white font-semibold mb-2">Emilie Gouache</p>
                                                <a
                                                    href="tel:+33678332375"
                                                    className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 text-sm sm:text-base"
                                                    aria-label="Appeler Emilie Gouache au 06 78 33 23 75"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                    </svg>
                                                    06 78 33 23 75
                                                </a>
                                            </div>

                                            {/* Alexis */}
                                            <div className="bg-white/10 rounded-xl p-4">
                                                <p className="text-white font-semibold mb-2">Alexis Moulin</p>
                                                <a
                                                    href="tel:+33626220251"
                                                    className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 text-sm sm:text-base"
                                                    aria-label="Appeler Alexis Moulin au 06 26 22 02 51"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                    </svg>
                                                    06 26 22 02 51
                                                </a>
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="mt-4">
                                            <a
                                                href="mailto:osmose.chiro@gmail.com"
                                                className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 text-sm sm:text-base"
                                                aria-label="Envoyer un email à osmose.chiro@gmail.com"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                </svg>
                                                osmose.chiro@gmail.com
                                            </a>
                                        </div>
                                    </section>

                                    {/* Bouton RDV */}
                                    <div className="mt-8">
                                        <a
                                            href={Helper.urlReservation}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ background: Helper.contentLetterColor }}
                                            className="inline-flex items-center justify-center w-full text-gray-900 font-semibold px-6 py-4 rounded-xl hover:opacity-90 transition-opacity shadow-lg"
                                            aria-label="Prendre rendez-vous en ligne"
                                        >
                                            Prendre rendez-vous en ligne
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>

                <Footer />
            </ScrollToTop>
        </>
    );
};

export default Contact;
